<div class='parkingpass-loading-screen h-100 row align-items-center'>

    <div class='col'>
        <fa-icon class='fa-stroopwafel' [icon]="faStroopwafel" [pulse]="true"></fa-icon>
    </div>

</div>